
<div class="w-100 mt-2">
    <div
        v-if   = "!editable"
        class  = "escalator-note"
        :style = "'max-height: ' + (rows * 24) + 'px'"
        v-html = "html"
    />
    <v-textarea
        v-else
        v-model     = "data.note"
        :label      = "$t('unit.escalator.tzb.note')"
        :rows       = "rows"
        maxlength   = "4000"
        class       = "pt-1"
        hide-details
        no-resize
    />
</div>
